import React from 'react'
import BG from '@/assets/home/home-tips-list-bg.png'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

import CARD1 from '@/assets/home/card1.png'
import CARD2 from '@/assets/home/card2.png'
import CARD3 from '@/assets/home/card3.png'

const cards: {
	icon: string
	title: string
	bg: string
	desc: string
}[] = [
	{
		icon: CARD1,
		title: 'swap.tips.card.title1',
		bg: BG,
		desc: 'swap.tips.card.content1',
	},
	{
		icon: CARD2,
		title: 'swap.tips.card.title2',
		bg: BG,
		desc: 'swap.tips.card.content2',
	},
	{
		icon: CARD3,
		title: 'swap.tips.card.title3',
		bg: BG,
		desc: 'swap.tips.card.content3',
	},
]

export default function HomeTips() {
	const { t } = useTranslation()
	return (
		<div className="relative z-10 mt-5 flex w-full flex-col px-2">
			<div className="flex flex-col items-center justify-center gap-0">
				<div className="tail-tips-title text-[1.75rem] font-semibold">{t('swap.tips.title')}</div>
				<span className="tail-tips-time -mt-5">2018</span>
			</div>
			<div className="w-full overflow-hidden py-4">
				<motion.div
					className="flex w-max space-x-6"
					animate={{ x: ['0%', '-50%'] }}
					transition={{
						duration: 20,
						ease: 'linear',
						repeat: Infinity,
					}}
				>
					{[...cards, ...cards].map((item, index) => (
						<div
							style={{
								background: `url(${item.bg}) no-repeat`,
								backgroundSize: '100% 100%',
							}}
							className="relative mb-2.5 flex h-[15.9375rem] w-[15.9375rem] flex-col items-center justify-center"
							key={index}
						>
							<div className="relative z-10 flex w-full items-center justify-center">
								<img src={item.icon} alt="" />
							</div>
							<div className="flex max-w-[11.5625rem] flex-col items-center justify-center gap-1">
								<div className="text-base font-semibold text-white">{t(item.title)}</div>
								<p className="text-center text-[0.6875rem] text-[#B7B2FF]">{t(item.desc)}</p>
							</div>
						</div>
					))}
				</motion.div>
			</div>
		</div>
	)
}
